// Auto-generated index of all GraphQL fragments
import { gql } from "@apollo/client";

// Import all fragment files
import customerFieldsContent from "./customerFields.graphql?raw";

// Export all fragments
export const fragments = {
  customerFields: gql(customerFieldsContent),
};
